import { render, staticRenderFns } from "./institutionDetail.vue?vue&type=template&id=38fb7fca&scoped=true&"
import script from "./institutionDetail.vue?vue&type=script&lang=js&"
export * from "./institutionDetail.vue?vue&type=script&lang=js&"
import style0 from "./institutionDetail.vue?vue&type=style&index=0&id=38fb7fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fb7fca",
  null
  
)

export default component.exports